module.exports = __webpack_public_path__ + "img/logo.5f5674e1.png";